import {TS} from "../../../../../../type/ts";
import {TraceIdentifiersVisitorOptions} from "../trace-identifiers-visitor-options";

/**
 * Traces identifiers for the given NewExpression.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function traceIdentifiersForNewExpression(_options: TraceIdentifiersVisitorOptions<TS.NewExpression>): void {
	// Do nothing
}
